import { useContext } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import OrderSummaryItem from '@r1-frontend/ui-react/organisms/OrderSummary/Item';

import { FullBuyContext, TFullBuyContextProperties } from '~/src/features/full-buy/analytics/context';
import getSummaryInfo from '~/src/features/full-buy/store/selectors/getSummaryInfo';

const Wrapper = styled.div`
    width: 100%;

    display: block;

    ${ButtonGroup} {
        margin-top: 16px;
        width: calc(100% + 32px);
    }

    ${ButtonGroup} button {
        width: 100%;
    }
`;

const TotalSummary = (): JSX.Element => {
    const { isVillage } = useContext<TFullBuyContextProperties>(FullBuyContext);
    const { total } = useSelector(getSummaryInfo(isVillage));

    return <Wrapper>
        <OrderSummaryItem
            Component={H4}
            title={'Итого при подключении:'}
            cost={total.cost}
            isMonthly={false}
        />
    </Wrapper>;
};

export default TotalSummary;
